import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { DataTablesModule } from "angular-datatables";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { UsersComponent } from "./users/users.component";
import { GroupsComponent } from "./groups/groups.component";
import { SignupComponent } from "./signup/signup.component";
import { BucketsComponent } from "./buckets/buckets.component";
import { HeaderComponent } from "./layout/header/header.component";
import { FooterComponent } from "./layout/footer/footer.component";
import { LayoutComponent } from "./layout/layout/layout.component";
import { FormsModule } from "@angular/forms";
import { AddUserComponent } from "./add-user/add-user.component";
import { S3objectComponent } from "./s3object/s3object.component";
import { ForgotPasswordModalComponent } from "./forgot-password-modal/forgot-password-modal.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { CreateBucketComponent } from "./create-bucket/create-bucket.component";
import { CreateGroupComponent } from "./create-group/create-group.component";
import { CreateIamUserComponent } from "./create-iam-user/create-iam-user.component";
import { GetSignedUrlComponent } from "./get-signed-url/get-signed-url.component";
import { IamComponent } from "./iam/iam.component";
import { ListPolicyComponent } from "./list-policy/list-policy.component";
import { LogoutComponent } from "./logout/logout.component";
import { NewPasswordChallangeComponent } from "./new-password-challange/new-password-challange.component";
import { UpdateGroupRolePolicyComponent } from "./update-group-role-policy/update-group-role-policy.component";
import { UpdateUserComponent } from "./update-user/update-user.component";
import { UploadS3ObjectComponent } from "./upload-s3-object/upload-s3-object.component";
import { ChartModule } from "primeng/primeng";
import { ToastrModule } from "ng6-toastr-notifications";
import { NgxSpinnerModule } from 'ngx-spinner';
import { DatePipe } from "@angular/common";
import { ProfileComponent } from './profile/profile.component';
import { GridBucketComponent } from './grid-bucket/grid-bucket.component';
import { InternationalPhoneModule } from 'ng4-intl-phone';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    UsersComponent,
    GroupsComponent,
    SignupComponent,
    BucketsComponent,
    HeaderComponent,
    FooterComponent,
    LayoutComponent,
    AddUserComponent,
    S3objectComponent,
    ForgotPasswordModalComponent,
    ChangePasswordComponent,
    CreateBucketComponent,
    CreateGroupComponent,
    CreateIamUserComponent,
    GetSignedUrlComponent,
    IamComponent,
    ListPolicyComponent,
    LogoutComponent,
    NewPasswordChallangeComponent,
    UpdateGroupRolePolicyComponent,
    UpdateUserComponent,
    UploadS3ObjectComponent,
    ProfileComponent,
    GridBucketComponent,
    
  ],
  imports: [
    BrowserModule,
    InternationalPhoneModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    DataTablesModule,
    NgbModule.forRoot(),
    BrowserAnimationsModule,
    ChartModule,
    NgxSpinnerModule,
    ToastrModule.forRoot()
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule {}
